// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ChevronRightDefault } from '../../../assets/icons/default/arrows/chevron-right.svg?react';
import { ReactComponent as ChevronRightSolid } from '../../../assets/icons/solid/arrows/CHEVRON-RIGHT.svg?react';
import { createIcons } from '../../Icon';
const ChevronRightIcon = /* @__PURE__ */ createIcons('ChevronRight', {
    default: ChevronRightDefault,
    solid: ChevronRightSolid
});
ChevronRightIcon.supportedTypes = ['default', 'solid'];
ChevronRightIcon.category = 'arrows';
export default ChevronRightIcon;
